// Feature flags must use direct NEXT_PUBLIC_* references so Next.js inlines them in client bundles.
export const getFeatureFlags = () => {
  return {
    exampleFeature: process.env.NEXT_PUBLIC_FEATURE_EXAMPLE === "true",
    googleDriveAttachments: process.env.NEXT_PUBLIC_FEATURE_GOOGLE_DRIVE_ATTACHMENTS === "true",
    savedViews: process.env.NEXT_PUBLIC_FEATURE_SAVED_VIEWS === "true",
    savedViewFavorites: process.env.NEXT_PUBLIC_FEATURE_SAVED_VIEW_FAVORITES === "true",
    supportChat: process.env.NEXT_PUBLIC_FEATURE_FLAG_SUPPORT_CHAT === "true",
    appleSignIn: process.env.NEXT_PUBLIC_FEATURE_APPLE_SIGN_IN === "true",
  } as const;
};

/**
 * Sign in with Apple is off by default. The Apple OAuth provider must be
 * configured in BOTH Supabase projects (and Apple Developer) before this is
 * flipped on, or the button is a dead-end. Gate the Apple button on this.
 */
export const isAppleSignInEnabled = (): boolean => getFeatureFlags().appleSignIn;

/**
 * The support chat widget no-ops without a configured Slack channel id —
 * `SupportChatButton` returns `null` when `NEXT_PUBLIC_SUPPORT_CHAT_CHANNEL_ID`
 * is absent, so the widget is never mounted. Any affordance that opens the
 * widget (e.g. the "Live chat" item in the user profile menu) MUST gate on this
 * same condition, or it becomes a dead-end button: visible, clicked, nothing
 * happens. This is the single source of truth for "the channel is configured".
 */
export const isSupportChatChannelConfigured = (): boolean =>
  Boolean(process.env.NEXT_PUBLIC_SUPPORT_CHAT_CHANNEL_ID);

/**
 * Support chat is genuinely usable only when BOTH the feature flag is on AND a
 * Slack channel is configured. Use this for the widget mount and any entry
 * point that opens it so the menu affordance and the widget can never diverge.
 */
export const isSupportChatAvailable = (): boolean =>
  getFeatureFlags().supportChat && isSupportChatChannelConfigured();
